define('boxes/helpers/loginHelper',['jquery', 'boxes/helpers/message-popup', 'boxes/helpers/tooltip'], function ($, messagePopup, toolTip) {
    'use strict';

    var ERROR_CLASS = 'has-error';
    var VALID_CLASS = 'is-valid';
    var INFO_MESSAGE_DATA_ATTRIBUTE = 'content-info';


    function handleErrorResponse(response, box) {
        // TODO: Remove special handling of system error, same msg popup anyway?
        if (response.RESULT === 'SYSTEM_ERROR') {
            showFailMessage(box, response.ERROR_HEADER, response.ERROR, response.BUTTON_TEXT);
        }
        showFailMessage(box, response.ERROR_HEADER, response.ERROR, response.BUTTON_TEXT);
    }

	function handleVerifyCodeErrorResponse(response, box) {
		var responseCode = response.ERROR;
		var errorHeader = response.ERROR_HEADER;
		var errorMessage = response.ERROR_MESSAGE;
		var buttonText = response.BUTTON_TEXT;
		var cancelButtonText = response.IN_BUTTON_TEXT;
		var customerSupportInfo = response.URL || response.SALESFORCE_URL;
		var confirmCallback = null;
		switch(responseCode) {
			case "VALIDATION_ERROR_4DIGITS_CODE":
				toolTip.showPopover(box.$box.find('input[name=POPUP_INPUT_FIELD]').parent(), response.ERROR_MESSAGE);
				return;
				break;
			case "CLOSED_ACCOUNT_ERROR_OPEN":
				//reopen now popup
				confirmCallback = function () {
					var parameters = {
						PARAM_EMAIL : box.$controller.boxes[1].model.email,
						PARAM_CODE : box.$controller.boxes[1].model.code
					};
					$.post('/pp?flow=OpenAccountNow', parameters, function (data) {
						showOneButtonPopup(box, data.HEADER, data.TEXT, data.BUTTON_TEXT, function(){
							console.log("ok");
							box.$controller.goToBox(box.$controller.boxes[1]);
						});
					});
				};
				break;
			case "CLOSED_ACCOUNT_ERROR_REOPEN_CUSTOMER_SUPPORT":
				confirmCallback = function(){
					$('#sliding-content-wrapper').find('.close').click();
					if(customerSupportInfo === response.URL) {
						window.open(customerSupportInfo);
					} else {
						if(window.helpCenter)
						{
							window.helpCenter.load("liveSupport");
						} else {
							console.log("Help center not found");
						}
					}

				};
				break;
			case "CLOSED_ACCOUNT_ERROR_REOPEN":
				confirmCallback = function() {
					$.post('/pp?flow=UpdateSuspendTimeResetPW', { PARAM_EMAIL: box.$controller.boxes[1].model.email, PARAM_CODE: box.$controller.boxes[1].model.code }, function(data) {
						if(data.RESULT === "OK") {
							showOneButtonPopup(box, data.RESPONSE_HEADER, data.RESPONSE_MESSAGE, data.RESPONSE_BUTTON, function () {
								$('#sliding-content-wrapper').find('.close').click();
							});
						} else if(data.RESULT === "NOT_OK") {
							showFailMessage(box, data.RESPONSE_HEADER, data.RESPONSE_MESSAGE, data.RESPONSE_BUTTON);
						}
					});
				};
				break;
			case "CLOSED_ACCOUNT_ERROR":
				confirmCallback = function(){
					$('#sliding-content-wrapper').find('.close').click();
					if(customerSupportInfo === response.URL) {
						window.open(customerSupportInfo);
					} else {
						if(window.helpCenter)
						{
							window.helpCenter.load("liveSupport");
						} else {
							console.log("Help center not found");
						}
					}
				};
				break;
			default:
				console.log("default");
				break;
		}

		//clear the old popup
		box.$box.find('.overlay').remove();
		showAccountClosedPopup(box, errorHeader, errorMessage, buttonText, cancelButtonText, confirmCallback, null);
	}

    function showFailMessage(box, title, message, buttonText) {
        messagePopup.show(box.$box, 'message-popup',{
            title: title,
            message: message,
            confirmButtonText: buttonText
        });
    }

    function showOneButtonPopup(box, title, message, buttonText, doneCallback) {
        var callbacks = {confirmButtonCallback: doneCallback};
        messagePopup.show(box.$box, 'one-button-popup',{
            title: title,
            message: message,
            confirmButtonText: buttonText
        }, callbacks);
    }

	function showVerifyCodePopup(box, title, message, confirmButtonText, cancelButtonText, confirmCallback, cancelCallback, doNotAutoClose) {
		var callbacks = {
			confirmButtonCallback: confirmCallback,
			closeButtonCallback: cancelCallback
		};
		return messagePopup.show(box.$box, 'popup-with-input-field', {
			title: title,
			message: message,
			confirmButtonText: confirmButtonText,
			cancelButtonText: cancelButtonText
		}, callbacks, doNotAutoClose);
	}

	function showAccountClosedPopup(box, title, message, confirmButtonText, cancelButtonText, confirmCallback, cancelCallback) {
    	var callbacks = {
    		confirmButtonCallback: confirmCallback,
			cancelButtonCallback: cancelCallback
		};
    	return messagePopup.show(box.$box, 'message-popup', {
    		title: title,
			message: message,
			confirmButtonText: confirmButtonText,
			closeButtonText: cancelButtonText
		}, callbacks);
	}

    function setupFocusPopover($elements) {
        $elements.off('focus').focus(function () {
            $('.popover').hide();
            var $inputElementParent = $(this).parent();
            if ($inputElementParent.hasClass(ERROR_CLASS)) {
                toolTip.showError($inputElementParent);
            } else {
                toolTip.showPopover($inputElementParent, $inputElementParent.data(INFO_MESSAGE_DATA_ATTRIBUTE));
            }
        });
    }

    function highlight(element, errorClass, validClass) {
        var $input = $(element);
        var $inputParent = $input.parent();
        $inputParent.addClass(errorClass).removeClass(validClass);
    }

    function unHighlight(element, errorClass, validClass) {
        var $input = $(element);
        var $inputParent = $input.parent();
        $inputParent.removeClass(errorClass).addClass(validClass);
        $inputParent.popover('destroy');
    }

    function errorPlacement(error, element) {
        $('.popover').hide();
        var $element = $(element).parent();
        toolTip.showError($element, $(error).text());
    }

    var loginHelper  = {};
    loginHelper.handleErrorResponse = handleErrorResponse;
    loginHelper.showOneButtonPopup = showOneButtonPopup;
	loginHelper.showVerifyCodePopup = showVerifyCodePopup;
	loginHelper.handleVerifyCodeErrorResponse = handleVerifyCodeErrorResponse;
	loginHelper.showAccountClosedPopup = showAccountClosedPopup;
    loginHelper.showFailMessage = showFailMessage;
    loginHelper.setupFocusPopover = setupFocusPopover;
    loginHelper.highlight = highlight;
    loginHelper.unHighlight = unHighlight;
    loginHelper.errorPlacement = errorPlacement;
    loginHelper.ERROR_CLASS = ERROR_CLASS;
    loginHelper.VALID_CLASS = VALID_CLASS;
    return loginHelper;
});

